import SubscribeForm from "components/SubscribeForm";

import styles from "./SocialFooter.module.css";

const SocialFooter: React.FC = () => {
  return (
    <>
      <div className={styles.socials}>
        <a
          className={styles.twitter}
          href="https://twitter.com/raycastapp"
          aria-label="Follow us on Twitter"
          rel="noopener noreferrer"
          target="_blank"
        >
          <svg width="33" viewBox="0 0 50 40" xmlns="http://www.w3.org/2000/svg" fill="#55ACEE">
            <path d="M15.4528 40C34.0158 40 44.1732 24.6063 44.1732 11.2796C44.1732 10.8465 44.1732 10.4134 44.1536 9.98031C46.122 8.56299 47.8347 6.77166 49.1929 4.74409C47.3819 5.55118 45.4331 6.08268 43.3858 6.33858C45.4724 5.09842 47.0669 3.11023 47.8347 0.74803C45.8858 1.90944 43.7204 2.73622 41.4173 3.18898C39.5669 1.22047 36.9488 0 34.0551 0C28.4842 0 23.9567 4.52756 23.9567 10.0984C23.9567 10.8858 24.0551 11.6536 24.2126 12.4016C15.8268 11.9882 8.38582 7.95276 3.40551 1.85039C2.53937 3.34646 2.04724 5.07874 2.04724 6.92913C2.04724 10.4331 3.83859 13.5237 6.53543 15.3347C4.88189 15.2756 3.32677 14.8228 1.9685 14.0748C1.9685 14.1142 1.9685 14.1536 1.9685 14.2126C1.9685 19.0944 5.45276 23.189 10.0591 24.1142C9.2126 24.3504 8.32677 24.4686 7.40158 24.4686C6.75197 24.4686 6.12204 24.4094 5.51181 24.2913C6.79133 28.3071 10.5315 31.2204 14.9409 31.2992C11.4763 34.0158 7.12599 35.6299 2.40158 35.6299C1.59449 35.6299 0.787401 35.5906 0 35.4921C4.44882 38.3268 9.76378 40 15.4528 40Z" />
          </svg>
          <h5>Stay up to date</h5>
          <p>
            We&rsquo;d love to stay connected with you. If the feeling&rsquo;s mutual, follow{" "}
            <strong>@raycastapp</strong> on Twitter for the latest news and updates.
          </p>
        </a>
        <a
          className={styles.slack}
          href="/community"
          aria-label="Join our community Slack"
          rel="noopener noreferrer"
          target="_blank"
        >
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.74592 20.2293C6.74592 22.0891 5.24394 23.5923 3.38555 23.5923C1.52716 23.5923 0.025177 22.0891 0.025177 20.2293C0.025177 18.3694 1.52716 16.8662 3.38555 16.8662H6.74592V20.2293ZM8.42611 20.2293C8.42611 18.3694 9.9281 16.8662 11.7865 16.8662C13.6449 16.8662 15.1469 18.3694 15.1469 20.2293V28.6369C15.1469 30.4968 13.6449 32 11.7865 32C9.9281 32 8.42611 30.4968 8.42611 28.6369V20.2293Z"
              fill="#E01E5A"
            />
            <path
              d="M11.7868 6.72612C9.92838 6.72612 8.42639 5.22293 8.42639 3.36306C8.42639 1.50318 9.92838 0 11.7868 0C13.6452 0 15.1471 1.50318 15.1471 3.36306V6.72612H11.7868ZM11.7868 8.43312C13.6452 8.43312 15.1471 9.93631 15.1471 11.7962C15.1471 13.6561 13.6452 15.1592 11.7868 15.1592H3.36037C1.50199 15.1592 0 13.6561 0 11.7962C0 9.93631 1.50199 8.43312 3.36037 8.43312H11.7868Z"
              fill="#36C5F0"
            />
            <path
              d="M25.2537 11.7962C25.2537 9.93631 26.7557 8.43312 28.6141 8.43312C30.4724 8.43312 31.9744 9.93631 31.9744 11.7962C31.9744 13.6561 30.4724 15.1592 28.6141 15.1592H25.2537V11.7962ZM23.5735 11.7962C23.5735 13.6561 22.0715 15.1592 20.2131 15.1592C18.3547 15.1592 16.8528 13.6561 16.8528 11.7962V3.36306C16.8528 1.50318 18.3547 0 20.2131 0C22.0715 0 23.5735 1.50318 23.5735 3.36306V11.7962V11.7962Z"
              fill="#2EB67D"
            />
            <path
              d="M20.2131 25.2739C22.0715 25.2739 23.5735 26.777 23.5735 28.6369C23.5735 30.4968 22.0715 32 20.2131 32C18.3547 32 16.8528 30.4968 16.8528 28.6369V25.2739H20.2131ZM20.2131 23.5923C18.3547 23.5923 16.8528 22.0891 16.8528 20.2293C16.8528 18.3694 18.3547 16.8662 20.2131 16.8662H28.6395C30.4979 16.8662 31.9999 18.3694 31.9999 20.2293C31.9999 22.0891 30.4979 23.5923 28.6395 23.5923H20.2131Z"
              fill="#ECB22E"
            />
          </svg>

          <h5>Help shape the product</h5>
          <p>
            Lots of the best and brightest ideas come from you. Join our Slack Community to help create the future of
            Raycast.
          </p>
        </a>
      </div>
      <div className={styles.newsletterContainer}>
        <div>
          <strong>Subscribe to our newsletter</strong>
          <p>
            Get a summary of what we&rsquo;ve shipped during the last month, behind the scenes updates, and team picks.
          </p>
        </div>
        <SubscribeForm />
      </div>
    </>
  );
};

export default SocialFooter;
